export default __webpack_public_path__ + "static/media/EM1700.34I-39959_-23769_0.62a2688e.jpg";